import type { MenuItem } from '@/config/menu';

/** One section owns a route; explicit named tabs outrank the section landing tab. */
export function activeMenuId(items: MenuItem[], pathname: string, search: string): string | undefined {
  const currentTab = new URLSearchParams(search).get('tab');
  const candidates = items.filter(item => !item.external && item.path).map(item => {
    const [path, query = ''] = item.path!.split('?');
    return { item, path, tab: new URLSearchParams(query).get('tab') };
  }).filter(({ path }) => pathname === path || pathname.startsWith(`${path}/`));
  candidates.sort((a, b) => b.path.length - a.path.length);
  const closest = candidates.filter(candidate => candidate.path === candidates[0]?.path);
  return (closest.find(candidate => candidate.tab === currentTab)
    ?? closest.find(candidate => candidate.tab === null || candidate.tab === '0')
    ?? closest[0])?.item.id;
}
